<template>
    <div class="BtnContainer" v-on:click="buttonClick" v-on:mouseover="hover = true" v-on:mouseleave="hover = false">
        <div class="circBtn">
            <div class="btnInner">
                <span class="iconClass" v-html="icon"></span>
            </div>
        </div>
        <div :class="buttonLabel()">
            <span :style="{'font-size':fontSize}" class="btnText">{{this.text}}</span>
        </div>

    </div>
</template>

<script>
    export default {
        name: "ButtonComponent.vue",
        props: ['icon', 'text', 'link', 'fontSize', 'dir'],
        data: ()=>{
            return{
                hover: false,
            }
        },
      methods:{
        buttonLabel(){
          let result = "";
          if(!this.dir || this.dir == 'right') {
            result += 'btnLabel ';
            if (this.hover) {
              result += "btnLabelHov ";
            }
          }
          else{
            result += 'btnLabelLeft ';
            if (this.hover) {
              result += "btnLabelHovLeft ";
            }
          }

          return result;
      },
            // button click function checks provided link prop and redirects to page, defaults to home
            buttonClick(){
                if(this.$props.link){
                    this.$router.push(this.$props.link);
                } else
                {
                    this.$router.push("/");
                }
            }
        }
    }
</script>

<style scoped>
    .BtnContainer{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .BtnContainer:hover{
        cursor: pointer;
    }
    .btnInner{
        height: 110px;
        width:110px;
        border-radius: 70px;
        border: 1px solid white;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .circBtn{
        background: #006DFF;
        height: 130px;
        width:130px;
        border-radius: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2;
    }
    .btnLabel{
        background: white;
        width: 250px;
        height: 80px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        margin-left: -15px ;
        border-radius: 0px 4px 4px 0px;
        border: 1px solid #8A8A8F;
        color:#006DFF;
        z-index: 1;
    }
    .btnLabelHov{
        background: #006DFF;
        width: 250px;
        height: 80px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        margin-left: -15px ;
        border-radius: 0px 4px 4px 0px;
        border: 1px solid #8A8A8F;
        color:#ffffff;
        z-index: 1;
    }
    .btnLabelLeft{
      order: -1;
      background: white;
      width: 250px;
      height: 80px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      margin-right: -15px ;
      border-radius: 0px 4px 4px 0px;
      border: 1px solid #8A8A8F;
      color:#006DFF;
      z-index: 1;
    }
    .btnLabelHovLeft{
      background: #006DFF;
      width: 250px;
      height: 80px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      border-radius: 0px 4px 4px 0px;
      border: 1px solid #8A8A8F;
      color:#ffffff;
      z-index: 1;
    }
    /*.btnLabel:hover{*/
    /*  background: #006DFF;*/
    /*    color: white;*/
    /*    cursor: pointer;*/
    /*}*/
    .btnText{
        font-family: RRPioneer;
        font-size: 28px;
        margin: 0 20px;
    }
    .iconClass{
      fill: #FFFFFF;
      height: 72px;
      width: 72px;
    }

</style>